<script setup lang="ts">
import { ModalSubscriptionDetails, ModalSubscriptionChangeProduct, ModalSubscriptionDiscount, ModalSubscriptionPause, ModalSubscriptionChangePause, ModalSubscriptionResume, ModalSubscriptionCancel, ModalSubscriptionPremiumTemplate, ModalSubscriptionAutoRenew, ModalSubscriptionSplit, ModalSubscriptionChargeNow, ModalOrderRetry, TableSubscriptions } from '@widgets/subscriptions'
import { SubscriptionModal } from '@entities/subscription'

import { useCustomerSubscriptionsPage } from '../model/customer-subscriptions-page.hook'

defineOptions({
  name: 'CustomerSubscriptionsPage',
})

const { activeModal, isRetryOpen } = useCustomerSubscriptionsPage()
</script>

<template>
  <TableSubscriptions :with-customer="false" />
  <ModalSubscriptionDetails
    v-if="activeModal === SubscriptionModal.Details"
    with-tasks
  />
  <ModalSubscriptionChangeProduct v-if="activeModal === SubscriptionModal.ChangeProduct" />
  <ModalSubscriptionDiscount v-if="activeModal === SubscriptionModal.Discount" />
  <ModalSubscriptionPause v-if="activeModal === SubscriptionModal.Pause" />
  <ModalSubscriptionChangePause v-if="activeModal === SubscriptionModal.ChangePause" />
  <ModalSubscriptionResume v-if="activeModal === SubscriptionModal.Resume" />
  <ModalSubscriptionCancel v-if="activeModal === SubscriptionModal.Cancel" />
  <ModalSubscriptionPremiumTemplate v-if="activeModal === SubscriptionModal.PremiumTemplate" />
  <ModalSubscriptionAutoRenew v-if="activeModal === SubscriptionModal.AutoRenew" />
  <ModalSubscriptionSplit v-if="activeModal === SubscriptionModal.Split" />
  <ModalSubscriptionChargeNow v-if="activeModal === SubscriptionModal.ChargeNow" />
  <ModalOrderRetry v-if="isRetryOpen" />
</template>
